<template>
  <div :class="{'input-group' : bootstrapStyling}">
    <!-- Calendar Button -->
    <span v-if="calendarButton" class="vdp-datepicker__calendar-button" :class="{'input-group-addon' : bootstrapStyling}" @click="showCalendar" v-bind:style="{'cursor:not-allowed;' : disabledPicker}">
      <i :class="calendarButtonIcon">
        {{ calendarButtonIconContent }}
        <span v-if="!calendarButtonIcon">&hellip;</span>
      </i>
    </span>
    <!-- Input -->
    <input
      :type="inline ? 'hidden' : 'text'"
      :class="computedInputClass"
      :name="name"
      :ref="refName"
      :id="id"
      :value="formattedValue"
      :open-date="openDate"
      :placeholder="placeholder"
      :clear-button="clearButton"
      :disabled="disabled"
      :required="required"
      @click="showCalendar"
      @keyup="parseTypedDate"
      @input="handleInput"
      @blur="inputBlurred">
    <!-- Clear Button -->
    <span v-if="clearButton && selectedDate" class="vdp-datepicker__clear-button" :class="{'input-group-addon' : bootstrapStyling}" @click="clearDate()">
      <i :class="clearButtonIcon">
        <span v-if="!clearButtonIcon">&times;</span>
      </i>
    </span>
  </div>
</template>
<script>
import DateUtils from '../utils/DateUtils'
import moment from 'moment'

export default {
  props: {
    selectedDate: Date,
    format: String,
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabledPicker: Boolean,
    disabled: Boolean,
    required: Boolean,
    bootstrapStyling: Boolean
  },
  data () {
    return {
      input: null,
      typedDate: false
    }
  },
  computed: {
    formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      if (this.typedDate) {
        return this.typedDate
      }
      return DateUtils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },

    computedInputClass () {
      let cssClass = [this.inputClass]
      if (this.bootstrapStyling) {
        cssClass.push('form-control')
      }
      return cssClass.join(' ')
    }
  },
  methods: {
    showCalendar () {
      this.$emit('showCalendar')
    },
    handleInput (e) {
      if (this.inline) return

      let val = e.target.value.replace(/\D/g, '')
      const isDeleting = e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward'

      if (val.length > 8) {
        val = val.slice(0, 8)
      }

      let res = ''
      if (val.length >= 1) {
        res += val.substr(0, 2)
      }
      if (val.length > 2) {
        res += '/' + val.substr(2, 2)
      }
      if (val.length > 4) {
        res += '/' + val.substr(4, 4)
      }

      // Proactive dash insertion
      if (!isDeleting) {
        if (val.length === 2 || val.length === 4) {
          if (res.length < 10 && !res.endsWith('/')) {
            res += '/'
          }
        }
      }

      e.target.value = res
      this.parseTypedDate()
    },
    /**
     * Attempt to parse a typed date
     */
    parseTypedDate () {
      const date = moment(this.input.value, this.format)
      const typedDate = date.valueOf()
      if (!isNaN(typedDate)) {
        this.typedDate = this.input.value
        this.$emit('typedDate', date.toDate())
      }
    },
    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred () {
      this.$emit('blurred')
      const date = moment(this.input.value, this.format)
      if (!this.typedDate) {
        return
      }
      if (isNaN(date.valueOf())) {
        this.clearDate()
      }
      this.input.value = null
      this.typedDate = null
    },
    /**
     * emit a clearDate event
     */
    clearDate () {
      this.$emit('clearDate')
    }
  },
  mounted () {
    this.input = this.$el.querySelector('input')
  }
}
// eslint-disable-next-line
;
</script>



// WEBPACK FOOTER //
// src/components/DatepickerCustom/src/components/DateInput.vue